<template>
  <EUIPageLayout
    :breadcrumbs="breadcrumbs"
    :title="`Application #${approval.referenceNumber}`"
    :loading="approvalLoading"
  >
    <template v-slot:body>
      <component v-if="!approvalLoading" :is="approvalType" />
    </template>
  </EUIPageLayout>
</template>

<script>
import EUIPageLayout from '@eui-template/page-layout';
import _get from 'lodash/get';
import { Notify } from 'quasar';
import { mapActions, mapMutations, mapState } from 'vuex';
import HRApprovalContract from '../hr-approval-contract';
import HRApprovalQuote from '../hr-approval-quote';

export default {
  name: 'HRApprovalWidget',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('hr', ['approval', 'approvalLoading']),
    approvalType() {
      const map = {
        [this.$Constants.APPROVAL_TYPES.NOVATED_CONTRACT]: HRApprovalContract,
        [this.$Constants.APPROVAL_TYPES.NOVATED_QUOTE]: HRApprovalQuote,
      };
      return map[this.approval.approvalType];
    },
    breadcrumbs() {
      const referenceNumber = _get(this, 'approval.referenceNumber');
      if (!referenceNumber) {
        return [];
      }
      const hrApprovalsRoute = this.$router.resolve({
        name: this.$RouteNames.hrApprovals,
      });
      return [
        { label: 'Requests', to: hrApprovalsRoute.href },
        { label: referenceNumber },
      ];
    },
  },
  methods: {
    ...mapMutations('hr', ['setState']),
    ...mapActions('hr', ['getHRApproval']),
  },
  async mounted() {
    this.setState(['quotePDFHref', undefined]);

    try {
      await this.getHRApproval({ id: this.id });
    } catch (err) {
      if (err === this.$Constants.APPROVAL_NOT_FOUND) {
        Notify.create({
          type: 'eui-negative',
          message: `Failed to fetch approval: ${this.id}`,
        });
        return this.$router.push({ name: this.$RouteNames.hrApprovals });
      } else {
        throw err;
      }
    }
  },
  components: {
    EUIPageLayout,
  },
};
</script>
